export class Days {
    day: number
    date: number
}

export class Slots {
    dateFrom: number
    dateTo: number
    isNow?:boolean
}



// WEBPACK FOOTER //
// ./src/types/SetAvailability.ts